import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Model

export class ChequeGiroLiteModel extends CommonModel {
  name: string;

  @Expose({ name: 'bank_code' })
  bankCode: string;

  @Expose({ name: 'is_active' })
  @Type(() => Boolean)
  isActive: boolean;
}

export class ChequeGiroModel extends ChequeGiroLiteModel {}

// Input

export type getChequeGirosInput = {
  params: CommonParamInput;
};

export type getChequeGiroInput = {
  id: string;
};

export type ChequeGiroMutationInput = {
  name: string;
  bankCode: string;
};

export type ChequeGiroUpdateInput = {
  chequeGiroId: string;
  body: ChequeGiroMutationInput;
};

export type ChequeGiroDeleteInput = {
  chequeGiroId: string;
};
